'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$75() {
  this.bm3 = null;
  this.bm4 = false;
}
export { $c_Lpresto_PrestoRouter$$anon$75 as $c_Lpresto_PrestoRouter$$anon$75 };
$p = $c_Lpresto_PrestoRouter$$anon$75.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$75;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$75() {
}
export { $h_Lpresto_PrestoRouter$$anon$75 as $h_Lpresto_PrestoRouter$$anon$75 };
$h_Lpresto_PrestoRouter$$anon$75.prototype = $p;
$p.bY = (function() {
  if ((!this.bm4)) {
    this.bm3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bm4 = true;
  }
  return this.bm3;
});
$p.P = (function() {
  return this.bY();
});
var $d_Lpresto_PrestoRouter$$anon$75 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$75, "presto.PrestoRouter$$anon$75", ({
  OS: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$75 as $d_Lpresto_PrestoRouter$$anon$75 };
//# sourceMappingURL=presto.-Presto-Router$$anon$75.js.map
